import React, { useEffect, useMemo, useRef, useState } from "react";
import { useStoreContext } from "../Contexts/StoreContext";
import { TbMapPinX, TbMoodConfuzed, TbSearch } from "react-icons/tb";
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_DINE_IN, ORDER_TYPE_TAKEAWAY } from '../Utils/Constants/Service';
import { useOrderTypeContext } from "../Contexts/OrderTypeContext";
import SlotAddressChoice from "../Components/Layout/SlotAddressChoice";
import HeaderLogo from "../Components/Layout/HeaderLogo";
import { debounce } from "lodash";
import Drawer from "../Components/Layout/Drawer";
import FormAddress from "../Components/Form/FormAddress";
import { ImSpinner8 } from "react-icons/im";
import { hideKeyboard, normalizeStringToSearch, orderTypeAsSlug, vibrate } from "../Utils/Helpers";
import { useLayoutContext } from "../Contexts/LayoutContext";
import { ADDRESS_TYPE_LOCALE, ADDRESS_TYPE_NOT_LISTED, ADDRESS_TYPE_OTHER, ADDRESS_TYPE_STORE_LIST, ALL_STATES } from "../Utils/Constants/Global";
import AddressService, { SearchProps } from "../Services/AddressService";
import CardStoreList from "../Components/Layout/CardStoreList";
import StoreService, { StoreListProps } from "../Services/StoreService";
import Modal from "../Components/Layout/Modal";
import Confirm from "../Components/Layout/Confirm";
import MultipleStoresFound from "../Components/Layout/MultipleStoresFound";
import { useStoreHook } from "../Hooks/StoreHook";
import ButtonClose from "../Components/Form/ButtonClose";
import Img from "../Components/Layout/Img";
import { useNavigate } from "react-router-dom";
import { useLoginHook } from "../Hooks/LoginHook";
import { useLoginContext } from "../Contexts/LoginContext";
import CustomerService from "../Services/CustomerService";
import { useAddressHook } from "../Hooks/AddressHook";
import ButtonLoginSSO from "../Components/Layout/ButtonLoginSSO";
import { IMaskInput } from "react-imask";
import ButtonLink from "../Components/Form/ButtonLink";
import BoxContentOrderTypeAndCurrentAddress from "../Components/Layout/BoxContentOrderTypeAndCurrentAddress";
import { useTranslation } from "react-i18next";
import BoxContentTranslate from "../Components/Layout/BoxContentTranslate";
import ButtonOrderTypeStart from "../Components/Layout/ButtonOrderTypeStart";

interface StartProps {
    isInDrawer?: boolean;
    showBackgroundImage?: boolean;
}

const Start = ({ showBackgroundImage = true, isInDrawer=false }: StartProps) => {
    const { t, i18n } = useTranslation();
    const { orderType, setOrderType, enabledOrderType, visibleOrderType, isDinein, isDelivery } = useOrderTypeContext();
    const { currentAddress, nextCurrentAddress, setNextCurrentAddress, setCurrentAddress, currentStore, setCurrentStore } = useStoreContext();
    const { company, loadingCompany, mainLoading, setMainLoading, setMainLoadingIcon, setMainLoadingIconNoSearchMap, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setShowStart, isMobile, states, setStates } = useLayoutContext();
    const { isAuthenticated } = useLoginContext();
    const [ searchAddress, setSearchAddress ] = useState('');
    const [ maskInputSearch, setMaskInputSearch ] = useState<any>();
    const [ isUsingZipcode, setIsUsingZipcode ] = useState<boolean>(true);
    const [ loadingSearchAddress, setLoadingSearchAddress ] = useState(false);
    const [ nextOrderType, setNextOrderType ] = useState<string | null>(orderType || null);
    const [ titleByService, setTitleByService ] = useState('')
    const [ subtitleByService, setSubtitleByService ] = useState('')
    const [ showFormAddress, setShowFormAddress ] = useState<boolean>(false);
    const [ showStoreList, setShowStoreList ] = useState<boolean>(false);
    const [ showStoreListBox, setShowStoreListBox ] = useState<boolean>(false);
    const [ storeList, setStoreList ] = useState<any[]>([]);
    const [ storeFilteredList, setStoreFilteredList ] = useState<any[]>([]);
    const [ customerAddressesList, setCustomerAddressesList ] = useState<any[]>([]);
    const [ loadingSearchCustomerAddresses, setLoadingSearchCustomerAddresses ] = useState(false);
    const [ isCurrentServiceVisible, setIsCurrentServiceVisible ] = useState<boolean>(false);
    const [ currentPosition, setCurrentPosition ] = useState<any>(null);
    const [ nextCurrentStore, setNextCurrentStore ] = useState<any>(null);
    const [ showConfirmStoreNavigation, setShowConfirmStoreNavigation ] = useState<boolean>(false);
    const [errorSearch, setErrorSearch] = useState<string|null>(null);
    const inputSearchRef = useRef<HTMLInputElement>(null);
    const { loadCompanyInfo, loadStoreInfo, getLinkToHome } = useStoreHook();
    const [loadingStores, setLoadingStores] = useState(false);
    const [isCreateAddressEnabled, setIsCreateAddressEnabled] = useState(false);
    const [storeAddresses, setStoreAddresses] = useState<any[]>([]);
    const [ isStoreNotFound, setIsStoreNotFound ] = useState<boolean>(false);
    const [ showBoxContentOrderTypeAndCurrentAddress, setShowBoxContentOrderTypeAndCurrentAddress ] = useState<boolean>(false);
    const { handleSSO } = useLoginHook();
    const { handleCreateAddress, search } = useAddressHook();
    const navigate = useNavigate();
    const [inputSearchState, setInputSearchState] = useState<string>('');

    let savedAddress: any = null;

    const [addressUseLocation, setAddressUseLocation] = useState({
        main_text: t('start.slot_address_choice.address_use_location.main_text'),
        secondary_text: '',
        title: ADDRESS_TYPE_LOCALE
    });

    const [onAddressNotListed, setOnAddressNotListed] = useState({
        main_text: t('start.slot_address_choice.address_not_listed.main_text'),
        secondary_text: t('start.slot_address_choice.address_not_listed.secondary_text'),
        title: ADDRESS_TYPE_NOT_LISTED,
        visible: false,
        search: ''
    });

    const [onNavigateToStoreList, setOnNavigateToStoreList] = useState({
        main_text: t('start.slot_address_choice.navigate_to_store_list.main_text'),
        secondary_text: t('start.slot_address_choice.navigate_to_store_list.secondary_text'),
        title: ADDRESS_TYPE_STORE_LIST,
        visible: true,
        search: ''
    });

    const handleService = (serviceName: string) => {
        setNextOrderType(serviceName);
        vibrate();
    }

    const handleCancelSearch = () => {
        setSearchAddress('');
        setErrorSearch('');
        handleSearch('');
    }

    //* Formatando endereço antes de salvar no currentAddress, localStorage e no payload do address/create
    const formatCurrentAddressToSave = (address: any) => {
        if (!address) return null;

        const {
            main_text,
            secondary_text,
            search,
            favoriteAddress,
            favoriteAddressOther,
            no_address_number,
            no_address_complement,
            ...rest
        } = address; //* Removendo campos desnecessários (utilizados apenas no frontend)

        const cleanedZipCode = address.zipcode
            ? String(address.zipcode).replace(/\D/g, '') //* Somente números
            : null;

        return {
            ...rest,
            number: address.number || 's/n',
            address: address.street,
            zipcode: cleanedZipCode,
            store_id: nextCurrentStore?.id,
            title: address.favoriteAddress === ADDRESS_TYPE_OTHER
                    ?   favoriteAddressOther
                    :   address.favoriteAddress,
        };
    };

    const handleCurrentAddress = () => {
        if (!nextCurrentAddress) return;

        setCurrentAddress(formatCurrentAddressToSave(nextCurrentAddress));
        setNextCurrentAddress(null);
    }

    const hasStoreChange = (store: any) => {
        if (currentStore && currentStore.id !== store.id) {
            setNextCurrentStore(store);
            setShowConfirmStoreNavigation(true);
            return true;
        }
        return false;
    }

    //* Navegar para a home da loja
    const handleNavigateToHome = (store: any) => {
        if (!nextOrderType) return;
        
        setShowStart(false);
        setMainLoading(true);
        setMainLoadingTitle(null);
        setMainLoadingMessage(t('layout.loading_main.default_message'));
        setOrderType(nextOrderType);
        setTimeout(() => { //* usado para armazenas states
            window.location.href = `/${orderTypeAsSlug(nextOrderType)}/${store.slug}`;
        }, 250);
    }

    const handleStoreNavigation = (store: any) => {
        if (!nextOrderType) return;

        setShowStoreList(false);
        setShowConfirmStoreNavigation(false);

        if (nextOrderType === ORDER_TYPE_DELIVERY) {

            if (savedAddress) {
                setCurrentAddress(savedAddress);
                savedAddress = null;
            }

            setNextCurrentStore(store);
            setCurrentStore(store);

            if (isCreateAddressEnabled) {
                setMainLoading(true);
                setMainLoadingTitle(t('start.form_address.save_address.loading_title'));
                setMainLoadingMessage(t('start.form_address.save_address.loading_message'));

                handleCreateAddress(formatCurrentAddressToSave(nextCurrentAddress))
                    .then(() => {})
                    .catch(() => {})
                    .finally(() => {
                        handleNavigateToHome(store);
                    });
            } else {
                handleCurrentAddress();
                handleNavigateToHome(store);
            }
        } else {
            handleNavigateToHome(store);
        }
    }

    const handleClickStore = (store: any) => {

        // Se estiver no drawer e for o mesmo tipo de serviço e mesma loja, apenas fechar o drawer
        if (isInDrawer && orderType === nextOrderType && currentStore && currentStore.id === store.id) {
            setShowStart(false);
            return;
        }

        if (!nextOrderType || hasStoreChange(store)) return;
        handleStoreNavigation(store);
    }

    const handleDirectSearch = async (params: SearchProps) => {
        search(params)
            .then((response) => handleStoreSearchResult(response))
            .catch((error: any) => {
                if (error?.response?.data?.error === 'no_stores_found') {
                    handleStoreNotFound();
                }
            })
            .finally(() => {
                setMainLoading(false);
            });
    }

    const handleSelectedAddress = (address: any, isUsingSavedAddress:boolean=false) => {
        setIsCreateAddressEnabled(!isUsingSavedAddress && isAuthenticated); //* Salvar endereço quando a busca não partir de um endereço salvo
        setNextCurrentAddress(address);

        //* Utilizado ao clicar no endereço salvo do cliente
        savedAddress = isUsingSavedAddress ? address : null;

        hasStoresInCity(address.city)
            .then((exists) => {
                if (!exists) {
                    handleStoreNotFound();
                } else {
                    if (isUsingSavedAddress) {
                        const searchParams = {
                            number: address.number,
                            zip_code: address.zipcode?.replace(/\D/g, ""), // somente números
                            lat: address.lat,
                            lng: address.lng
                        };
                        handleDirectSearch(searchParams);
                    } else {
                        setMainLoading(false);
                        setShowFormAddress(true);
                    }
                }
            });
    }

    const handleAddressNotListedButtonClick = () => {
        autoCompleteGoogle(onAddressNotListed.search);
    }

    const handleNavigateStoreList = () => {
        setShowStart(false);
        navigate('/lojas');
    }

    const handleCancelFormAddress = () => {
        setShowFormAddress(false);
        setNextCurrentAddress(null);
        setShowStoreList(false);
    }

    const handleStoreNotFound = () => {
        setMainLoading(false);
        setShowFormAddress(false);
        setNextCurrentAddress(null);
        setShowStoreList(false);
        setCurrentAddress(null);
        setNextOrderType(null);
        setIsStoreNotFound(true);
    }

    const getCustomerAddresses = async () => {
        //* Buscando endereços do usuário logado
        if (!isAuthenticated || nextOrderType === null || customerAddressesList.length > 0) return;

        try {
            setLoadingSearchCustomerAddresses(true);
            const customerService = new CustomerService(nextOrderType);
            const response = await customerService.getCustomerAddresses();

            if (response) {
                setCustomerAddressesList(response);
            }
        } catch (error: any) {
            setCustomerAddressesList([]);
        } finally {
            setLoadingSearchCustomerAddresses(false);
        };

    }

    const handleSearch = (value: string) => {
        if (value) {
            autoComplete(value);
        } else {
            setStoreAddresses([]);
        }
    }

    const updateTextLanguages = () => {
        setAddressUseLocation(prev => ({
            ...prev,
            title: ADDRESS_TYPE_LOCALE,
            main_text: t('start.slot_address_choice.address_use_location.main_text'),
        }));

        setOnAddressNotListed(prev => ({
            ...prev,
            main_text: t('start.slot_address_choice.address_not_listed.main_text'),
            secondary_text: t('start.slot_address_choice.address_not_listed.secondary_text'),
            title: ADDRESS_TYPE_NOT_LISTED,
        }));

        setOnNavigateToStoreList(prev => ({
            ...prev,
            main_text: t('start.slot_address_choice.navigate_to_store_list.main_text'),
            secondary_text: t('start.slot_address_choice.navigate_to_store_list.secondary_text'),
            title: ADDRESS_TYPE_STORE_LIST,
        }));
    }

    useEffect(() => {
        setErrorSearch(null);
        setSearchAddress('');

        const maskAnyInput = /^[a-zA-ZÀ-ÿ0-9 ,./]+$/;
        const maskByZipcode = '00000-000';

        switch (nextOrderType) {
            case ORDER_TYPE_DELIVERY:
                setMaskInputSearch(isUsingZipcode ? maskByZipcode : maskAnyInput);
                setTitleByService(isUsingZipcode ? t('start.search.placeholder_by_zipcode') : t('start.search.placeholder_by_address'));
                setSubtitleByService(t('start.service.delivery.subtitle'));
                break;
            case ORDER_TYPE_DINE_IN:
                setMaskInputSearch(maskAnyInput);
                setTitleByService(t('start.service.dine_in.title'));
                setSubtitleByService(t('start.service.dine_in.subtitle'));
                break;
            default:
                setTitleByService('');
                setSubtitleByService('');
                break;
        }

        setInputSearchState(isUsingZipcode ? '' : currentPosition?.state);

        setTimeout(() => {
            if (nextOrderType === ORDER_TYPE_DELIVERY && inputSearchRef.current && !showBoxContentOrderTypeAndCurrentAddress) {
                inputSearchRef?.current?.focus();
            }
        }, 10);

        if (nextOrderType) {
            setIsStoreNotFound(false);
        }

        updateTextLanguages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType, isUsingZipcode, showBoxContentOrderTypeAndCurrentAddress, i18n.language]);

    useEffect(() => {
        if (!searchAddress) {
            handleCancelSearch();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchAddress]);

    useEffect(() => {
        if (nextOrderType === ORDER_TYPE_DELIVERY) {
            getCustomerAddresses();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType]);

    const addressByLatLng = async (text: string) => {
        try {
            const addressSevice = new AddressService(orderType);
            const getAddressByLatLng = await addressSevice.addressByLatLng(text);

            const { street, number, complement, neighborhood, city, state, zipcode } = getAddressByLatLng;
            const formatSecondaryText = [street?.trim(), number?.trim(), complement?.trim(), neighborhood?.trim(), city?.trim(), state?.trim(), zipcode?.trim()]
                .filter(Boolean)
                .join(", ");

            setCurrentPosition((prev: any) => ({
                ...prev,
                state
            }));

            setAddressUseLocation((prev) => ({
                ...prev,
                secondary_text: formatSecondaryText,
                street: getAddressByLatLng.street,
                number: getAddressByLatLng.number,
                complement: getAddressByLatLng.complement,
                neighborhood: getAddressByLatLng.neighborhood,
                zipcode: getAddressByLatLng.zipcode,
                city: getAddressByLatLng.city,
                state: getAddressByLatLng.state
            }));

        } catch (error: any) {
            setLoadingSearchAddress(false);
        } finally {}
    }

    const hasStoresInCity = async (text: string) => {
        try {
            setMainLoading(true);
            setMainLoadingIcon(true);
            setMainLoadingTitle(t('start.search_store_in_city.loading_title'));
            setMainLoadingMessage(t('start.search_store_in_city.loading_message'));

            const storeSevice = new StoreService(orderType);
            const res = await storeSevice.hasStoresInCity(text);
            return res.exists;
        }
        catch (error) {
            setMainLoading(false);
            throw error;
        }
    }

    const checkGeolocationPermission = async () => {
        if (!navigator.permissions) return null;
        const result = await navigator.permissions.query({ name: "geolocation" });
        return result.state; // possíveis: "granted" | "denied" | "prompt"
    };

    const handleLocationButtonClick = async () => {
        const state = await checkGeolocationPermission();
        if (state === "prompt") { // usuário ainda não decidiu. Vai abrir o pop-up
          handleGeolocation();
        } else if (state === "denied") {
            setMainLoading(true);
            setMainLoadingIcon(false);
            setMainLoadingIconNoSearchMap(true);
            setMainLoadingTitle(t('layout.geolocation_permission.denied.title'));
            setMainLoadingMessage(t('layout.geolocation_permission.denied.message'));
            setMainLoadingCloseButton(true);
        } else {
          handleGeolocation().then(() => {
            handleSelectedAddress(addressUseLocation);
          });
        }
    };

    const handleGeolocation = async () => {
        try {
            new Promise<GeolocationPosition>((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true, // tenta usar GPS
                    timeout: 10000,           // até 5s de espera
                    maximumAge: 0             // não usa cache
                });
            }).then((position) => {
                setCurrentPosition((prev: any) => ({
                    ...prev,
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                }));

                const textAddressByLatLng = `${position.coords.latitude}, ${position.coords.longitude}`;
                addressByLatLng(textAddressByLatLng);
            }).catch(() => {
                setCurrentPosition((prev: any) => ({
                    ...prev,
                    latitude: null,
                    longitude: null,
                }));

            });
        } catch (error: any) {}
    }

    const [isFirstRender, setIsFirstRender] = useState(true);
    useEffect(() => {

        if (!isInDrawer) {
            loadCompanyInfo();
        }
        if (currentStore) {
            loadStoreInfo(currentStore.id, false);
        }
        handleGeolocation();
        setStates(ALL_STATES);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (visibleOrderType?.length === 1) {
            handleService(visibleOrderType[0].name);
            if (visibleOrderType[0].name === ORDER_TYPE_DINE_IN) {
                loadStoresList(currentPosition);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visibleOrderType]);

    useEffect(() => {
        loadStoresList(currentPosition)
        if (!currentPosition) {
            handleGeolocation();
        } else if (currentPosition?.state && !inputSearchState) {
            setInputSearchState(currentPosition.state);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPosition]);

    useEffect(() => {
        if (searchAddress) {
            handleChangeInputSearch(searchAddress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputSearchState]);

    useEffect(() => {
        const checkVisibility = enabledOrderType.some((service: any) => service.name === nextOrderType && service.visible);
        setIsCurrentServiceVisible(checkVisibility);

        if (nextOrderType === ORDER_TYPE_DINE_IN) {
            loadStoresList(currentPosition);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextOrderType, enabledOrderType, showBoxContentOrderTypeAndCurrentAddress]);

    const handleScroll = () => {
        const element = document.getElementById("contentToScroll");
        setTimeout(() => {
            element?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 10)
    }

    useEffect(() => {
        if (storeAddresses.length > 0) {
            hideKeyboard();
            handleScroll();
        }

        //* exibindo 'busca avançada' pelo google
        setOnAddressNotListed((prev: any) => ({
            ...prev,
            visible: storeAddresses.length > 0,
            search: searchAddress
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeAddresses]);

    useEffect(() => {
        if (!showStoreList) {
            setStoreList([]);
            setStoreFilteredList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showStoreList]);
    
    useEffect(() => {
        setShowStoreListBox(
            (nextOrderType === ORDER_TYPE_DELIVERY && storeAddresses.length > 0)
            || (
                (nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY) 
                && (storeFilteredList?.length > 0 || loadingStores)
            )
        )
    }, [nextOrderType, storeAddresses, storeFilteredList, loadingStores]);

    useEffect(() => {
        if (company) {
            document.title = currentStore ? currentStore.name : company.name;
        }
        if (!company && !isInDrawer) return;
        handleSSO();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company])

    const autoComplete = async (value: string) => {
        try {
            setLoadingSearchAddress(true);
            const addressSevice = new AddressService(orderType);
            const getResult = await addressSevice.autocomplete(value);

            searchAddressResult(getResult);

        } catch (error: any) {
            const e = error?.response?.data?.message ? error?.response?.data?.message : t('errors.default_title');
            setErrorSearch(e);
        } finally {
            setLoadingSearchAddress(false);
        }
    }

    const autoCompleteGoogle = async (value: string) => {
        try {
            setLoadingSearchAddress(true);
            const addressSevice = new AddressService(orderType);
            const getResult = await addressSevice.autocompleteGoogle(value);

            searchAddressResult(getResult);

        } catch (error: any) {
            setErrorSearch(error.response.data.message);
        } finally {
            setLoadingSearchAddress(false);
        }
    }

    const searchAddressResult = (result: any) => {
        setStoreAddresses(result);
        setErrorSearch(null);

        if (result.length === 0) {
            setErrorSearch(t('start.no_address_found'));
        }
    }

    const loadStoresList = async (params: StoreListProps) => {
        if (!nextOrderType) return;

        setLoadingStores(true);
        try {
            const storeService = new StoreService(nextOrderType);
            const payload = {
                state: params.state?.toLowerCase(),
                latitude: params.latitude,
                longitude: params.longitude,
            }
            const stores = await storeService.stores(payload);

            setStoreList(stores);
            setStoreFilteredList(stores);
            if (stores && stores.length > 0) {
                setTimeout(() => {
                    handleScroll();
                }, 100);
            }
        } catch (error) {
            setStoreList([]);
        } finally {
            setLoadingStores(false);
        }
    }

    // Busca automatica por CEP com 9 digitos (sem delay)
    const debouncedSearch = useMemo(() => {
        return debounce((value: string, inputLength: number) => {
            if (!isUsingZipcode || (isUsingZipcode && inputLength === 9)) {
                handleSearch(value);
            }
        }, isUsingZipcode ? 0 : 1200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUsingZipcode]);

    // cleanup para evitar chamadas pendentes ao desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const handleChangeInputSearch = (inputValue: string) => {
        const inputState = Boolean(inputSearchState) ? `${inputSearchState}, ` : '';
        const concatenatedValues = inputState + inputValue;

        if (!addressUseLocation?.secondary_text) {
            handleGeolocation();
        }
        if (nextOrderType === ORDER_TYPE_DELIVERY) {
            debouncedSearch(concatenatedValues, inputValue.length);
        } else if (nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY) {
            const filteredStores = storeList.filter((store) => {
                const search = normalizeStringToSearch(inputValue);
                const fields = [store.name, store.address, store.neighborhood, store.city];
                return fields.some((field) => normalizeStringToSearch(field).includes(search));
            });
            setStoreFilteredList(filteredStores)
        }
    }

    const handleStoreSearchResult = (stores: any[]) => {
        if (!stores || stores.length === 0) return;

        if (stores.length === 1) {
            const store = stores[0];

            if (hasStoreChange(store)) return;

            handleClickStore(store);
            handleCurrentAddress();
            return;
        }

        setStoreList(stores);
        setShowStoreList(true);
    };

    useEffect(() => {
        setShowBoxContentOrderTypeAndCurrentAddress(Boolean(isFirstRender && !isStoreNotFound && !mainLoading && ((isDinein && currentStore) || (isDelivery && currentAddress))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreNotFound, mainLoading, currentAddress, isDinein, isDelivery, isFirstRender]);

    return (
        <>

            <div className="flex w-full h-dvh md:h-screen md:flex-row relative">

                {!isInDrawer && orderType && ((isDinein && currentStore) || (isDelivery && currentAddress)) &&
                    <ButtonClose fixedOnTop onClick={() => navigate(getLinkToHome())} className="z-90 text-white md:text-gray-400 bg-black/20 hover:bg-black/35 active:bg-black/35 md:bg-transparent md:hover:bg-gray-100" />
                }

                {(showBackgroundImage || isMobile) &&
                    <div
                        className={`fixed md:static w-full bg-gray-600 bg-cover bg-center bg-no-repeat ${company ? 'h-[35dvh] md:h-dvh' : 'h-dvh'}`}
                        style={{backgroundImage: `url(${!loadingCompany ? company?.background_images?.desktop : ''} )`}}
                    >
                        {!company?.background_images?.desktop &&
                            <div className="flex flex-col gap-3 items-center justify-center w-full h-full opacity-10">
                                <Img src="/logo-ditti-tagme-white.png" alt="Ditti by" className="w-full max-w-40 md:max-w-64 transform-width transition-all duration-700 ease-in-out" />
                                {loadingCompany && <div className="flex items-center justify-center font-medium gap-1.5 text-white"><ImSpinner8 className="animate-spin" /></div>}
                            </div>
                        }
                    </div>
                }

                {company && 
                    <div className={`
                        relative
                        w-screen max-w-full md:max-w-md
                        transition-all ease-in-out
                        bg-white z-20 mt-[32dvh] md:mt-0 md:overflow-y-auto grid md:place-items-center rounded-2xl md:rounded-none shadow-reverse-xl shadow-black/15
                        `}>

                        <div className="relative flex flex-col md:h-full w-full md:rounded-none ">

                            {!showBoxContentOrderTypeAndCurrentAddress && <BoxContentTranslate onlyFlags className="absolute top-2 left-2" />}

                            <section className={`flex items-center justify-center h-full transition-all ${isCurrentServiceVisible ? 'max-h-max' : 'min-h-full___'}`}>
                                <div className="grid gap-5 p-4 self-start md:self-auto w-full bg-white rounded-t-2xl md:rounded-none">

                                    <div className="flex items-center justify-center pt-2"><HeaderLogo className="pointer-events-none max-w-40" /></div>

                                    { isStoreNotFound && 
                                        <div className="grid place-items-center gap-2">
                                            <TbMapPinX size={50} className="text-shopfood-error zoomInIcon" />
                                            <h1 className="text-xl px-4 font-bold leading-none text-custom-primary text-center">
                                                {t('start.no_store_found')}
                                            </h1>
                                        </div>
                                    }

                                    {showBoxContentOrderTypeAndCurrentAddress &&
                                        <div className=" inset-0 rounded-t-2xl md left-auto w-full md:max-w-md h-full z-40 flex items-center bg-white/90 backdrop-blur-sm">
                                            <BoxContentOrderTypeAndCurrentAddress onContinue={() => {setShowBoxContentOrderTypeAndCurrentAddress(false); setIsFirstRender(false);}} />
                                        </div>
                                    }

                                    {!isCurrentServiceVisible && visibleOrderType.length > 0 && !currentAddress && 
                                        <h1 className="text-xl px-4 font-bold leading-none text-shopfood-title text-center">
                                            {isStoreNotFound ? t('start.title_1') : t('start.title_2')}
                                        </h1>
                                    }

                                    {isCurrentServiceVisible && visibleOrderType.length === 0 &&
                                        <div className='h-full flex items-center justify-center gap-1 text-gray-400 px-4'>
                                            <TbMoodConfuzed />
                                            <span>{t('start.no_active_services')}</span>
                                        </div>
                                    }

                                    {!showBoxContentOrderTypeAndCurrentAddress &&
                                        <div className="flex justify-center gap-2">
                                            {visibleOrderType.map((service: any, index: number) => 
                                                <ButtonOrderTypeStart
                                                    key={index}
                                                    service={service}
                                                    nextOrderType={nextOrderType}
                                                    onHandleClick={(e: string) => handleService(e)}
                                                />
                                            )}
                                        </div>
                                    }

                                    {!showBoxContentOrderTypeAndCurrentAddress &&
                                        <>
                                            <div id="contentToScroll" className="h-0.5"></div>

                                            {isCurrentServiceVisible && subtitleByService &&
                                                <h1 className="px-4 font-bold leading-none text-xl text-shopfood-title text-center">
                                                    {subtitleByService}
                                                </h1>
                                            }
                                        </>
                                    }

                                    {Boolean(nextOrderType && !showBoxContentOrderTypeAndCurrentAddress 
                                        && ((nextOrderType === ORDER_TYPE_DELIVERY) 
                                        || (
                                            (nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY) 
                                            && storeList && storeList.length > 1 && !loadingStores))
                                    ) &&
                                        <div className={`grid w-full gap-2 rounded-xl transition-all ${isCurrentServiceVisible ? 'h-auto opacity-100' : 'h-0 opacity-0'}`}>

                                            <div className='flex w-full h-14'>
                                                {(!isUsingZipcode && nextOrderType === ORDER_TYPE_DELIVERY) &&
                                                    <select
                                                        name="state"
                                                        value={inputSearchState}
                                                        disabled={loadingSearchAddress}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setInputSearchState(e.target.value)}
                                                        className="p-2.5 py-3 ring-1 ring-gray-300 bg-white rounded-l-lg w-16 h-full font-bold disabled:bg-gray-100"
                                                        >
                                                        <option value="">---</option>
                                                        {states.map((uf: string) => (
                                                            <option key={uf} value={uf}>{uf}</option>
                                                        ))}
                                                    </select>
                                                }

                                                <div className="relative w-full flex items-center justify-between">
                                                    <div className="absolute left-3 text-shopfood-title">
                                                        {!loadingSearchAddress && <TbSearch size={20} />}
                                                        {loadingSearchAddress && <ImSpinner8 size={15} className='animate-spin' />}
                                                    </div>
                                                    <IMaskInput
                                                        name="searchAddress"
                                                        mask={maskInputSearch}
                                                        inputMode={isUsingZipcode ? 'numeric' : 'text'}
                                                        lazy={true}
                                                        autoComplete="on"
                                                        inputRef={inputSearchRef}
                                                        unmask="typed"
                                                        value={searchAddress}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            const value = event.target.value;
                                                            setSearchAddress(value);
                                                            handleChangeInputSearch(value);
                                                        }}
                                                        disabled={(nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY) && storeList && storeList.length === 1}
                                                        placeholder={titleByService}
                                                        className={`
                                                            block w-full text-shopfood-title border-0 p-2 pl-9 h-full
                                                            ${isUsingZipcode ? 'text-xl font-extrabold' : 'text-lg'}
                                                            ${isUsingZipcode || nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY ? 'rounded-lg' : 'rounded-r-lg'}
                                                            ${searchAddress && 'pr-10'}
                                                            ring-1 ring-gray-300 placeholder:text-gray-400 leading-none placeholder:font-medium placeholder:text-lg font-bold focus:ring-2 focus:ring-shopfood-title transition-all ease-in-out duration-200`}
                                                    />
                                                    <div className="absolute right-1.5 text-gray-400">
                                                        {nextOrderType === ORDER_TYPE_DELIVERY &&
                                                            <>
                                                                {isUsingZipcode && Boolean(!searchAddress) && <ButtonLink onClick={() => {setIsUsingZipcode(false); vibrate()}} className="h-9 w-max justify-center zoomInIconNoDelay text-sm text-gray-500">{t('start.dont_know_zipcode')}</ButtonLink>}
                                                                {!isUsingZipcode && Boolean(!searchAddress) && <ButtonLink onClick={() => {setIsUsingZipcode(true); vibrate()}} className="h-9 w-max justify-center zoomInIconNoDelay text-sm text-gray-500">{t('start.search_by_zipcode')}</ButtonLink>}
                                                            </>
                                                        }
                                                        {searchAddress && <ButtonClose disabled={loadingSearchAddress} onClick={handleCancelSearch} className="zoomInIconNoDelay mr-1.5" />}
                                                    </div>
                                                </div>
                                            </div>

                                            {errorSearch && <div className='text-xs font-medium text-shopfood-error'>{errorSearch}</div>}
                                        </div>
                                    }

                                </div>
                            </section>

                            {!showBoxContentOrderTypeAndCurrentAddress &&
                                <section className={`flex flex-col divide-y divide-gray-50 bg-white transition-all -mt-0 seft-start h-full overflow-hidden
                                        ${isCurrentServiceVisible ? 'min-h-max opacity-100' : 'h-0 opacity-0'}
                                    `}>

                                    {(showStoreListBox) &&
                                        <section className={`
                                                ${nextOrderType === ORDER_TYPE_DELIVERY ? 'py-2 px-4' : 'p-4 h-full'}
                                                ${(storeFilteredList.length > 0) ? 'bg-gray-50' : ''}
                                                ${loadingStores ? 'bg-transparent' : ''}
                                            `}>

                                            <div className='grid self-start gap-2'>
                                                {nextOrderType === ORDER_TYPE_DELIVERY &&
                                                    storeAddresses.map((address: any, index: number) =>
                                                        <SlotAddressChoice key={index} address={address} onHandleClick={(e: any) => handleSelectedAddress(e) } />
                                                )}

                                                {(nextOrderType === ORDER_TYPE_DINE_IN || nextOrderType === ORDER_TYPE_TAKEAWAY) &&
                                                    <>
                                                        {loadingStores
                                                            ?   <div className="flex items-center justify-center gap-1 text-gray-400">
                                                                    <ImSpinner8 className="animate-spin" />
                                                                    <span>{t('start.loading_stores')}</span>
                                                                </div>
                                                            :   storeFilteredList.map((store: any) => <CardStoreList onCardClick={() => handleClickStore(store)} store={store} key={`${store.id}`} />)
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </section>
                                    }

                                    {(nextOrderType === ORDER_TYPE_DELIVERY && isAuthenticated) &&
                                        <>
                                            {loadingSearchCustomerAddresses
                                                ?   <section className="flex items-center gap-1 text-gray-400 py-4 mx-2 ml-12 text-sm text-gray-400">
                                                        <ImSpinner8 className="animate-spin" />
                                                        <span className="text-sm">{t('start.loading_customer_addresses')}</span>
                                                    </section>
                                                :   customerAddressesList.length > 0 &&
                                                        <section className='grid p-4 bg-gray-50'>
                                                            <h4 className="mx-2 ml-11 text-sm -mt-2 pb-2 text-gray-400">{t('start.customer_addresses_title')}</h4>
                                                            <div className='grid gap-2'>
                                                                {customerAddressesList.map((address: any, index: number) => {
                                                                    return <SlotAddressChoice isAddressSaved key={index} address={address} onHandleClick={(e: any) => handleSelectedAddress(e, true) } />
                                                                })}
                                                            </div>
                                                        </section>
                                            }
                                        </>
                                    }

                                    {(nextOrderType === ORDER_TYPE_DELIVERY && addressUseLocation?.secondary_text) &&
                                        <section className="pb-2 px-4 flex h-max">
                                            <SlotAddressChoice address={addressUseLocation} onHandleClick={(e: any) => handleLocationButtonClick()} />
                                        </section>
                                    }

                                    {(nextOrderType === ORDER_TYPE_DELIVERY && onAddressNotListed.visible) &&
                                        <section className="p-2 px-4 flex h-max">
                                            <SlotAddressChoice address={onAddressNotListed} onHandleClick={handleAddressNotListedButtonClick} />
                                        </section>
                                    }

                                    {(nextOrderType === ORDER_TYPE_DELIVERY && !loadingStores) &&
                                        <section className="p-2 px-4 flex h-max">
                                            <SlotAddressChoice address={onNavigateToStoreList} onHandleClick={handleNavigateStoreList} />
                                        </section>
                                    }

                                </section>
                            }

                            {!showBoxContentOrderTypeAndCurrentAddress && !isAuthenticated && company && company.sso_active &&
                                <section className="grid p-4 md:py-6 gap-0.5 md:gap-1 place-items-center w-full sticky bottom-0 bg-white/75 backdrop-blur-sm md:container">
                                    <h4 className="font-semibold leading-none">{t('start.sso.title')}</h4>
                                    <p className="text-sm text-gray-400 leading-none text-center">{t('start.sso.subtitle')}</p>
                                    <ButtonLoginSSO className="mt-2 w-full max-w-80" />
                                </section>
                            }

                        </div>
                    </div>
                }

            </div>

            <Drawer
                open={showFormAddress}
                onClose={handleCancelFormAddress}
                fromBottom={isMobile}
                title={t('start.form_address.drawer_title')}
                >
                <div className="flex flex-col gap-4 h-full">
                    <FormAddress
                        onSuccess={(stores: any) => handleStoreSearchResult(stores)}
                        onCancel={handleCancelFormAddress}
                        onStoreNotFound={handleStoreNotFound}
                    />
                </div>
            </Drawer>

            <Drawer
                open={showStoreList}
                onClose={() => setShowStoreList(false)}
                fromBottom={isMobile}
                className={'p-0'}
                classNameChildren={'p-0'}
                >
                    <MultipleStoresFound
                        stores={storeList}
                        onHandleClick={(store: any) => handleClickStore(store)}
                        onCancel={() => setShowStoreList(false)}
                    />
            </Drawer>

            <Modal open={showConfirmStoreNavigation} className="max-w-md m-4" onClose={() => setShowConfirmStoreNavigation(false)}>
                <Confirm
                    onConfirm={() => handleStoreNavigation(nextCurrentStore)}
                    onCancel={() => setShowConfirmStoreNavigation(false)}
                    title={t('layout.store_list.confirm_change_title')}
                    message={t('layout.store_list.confirm_change_message', {currentStore: currentStore?.name, newStore: nextCurrentStore?.name})}
                    labelConfirm={t('layout.store_list.confirm_button_label')}
                />
            </Modal>
        </>
    );
};

export default Start;